import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { DokumentType } from '@features/dokumenter/dokument-type.model';

@Injectable({
  providedIn: 'root'
})
export class DokumentTypeApi extends RestApi<DokumentType> {
  endpoint = '/api/admin/dokumenttyper';
}
